import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BatchPrint from './BatchPrint';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom';
import { usePermissionViewModel } from '../../permissions/viewmodel/permission-viewmodel';


const OrderActionButtons = ({ orderId, handleDeleteOrder, order }) => {
  const [loading, setLoading] = useState(false);
  const {hasPermission} = usePermissionViewModel('commande')

  
  const handlePrint = async () => {
    // Check if order data exists
    if (!order || Object.keys(order).length === 0) {
      console.error("Order data is missing or empty:", order);
      toast.error("Données de commande manquantes. Impossible de générer l'étiquette.");
      return;
    }
    
    setLoading(true);
    
    try {
      // Create a new window for printing
      const printWindow = window.open('', '_blank');
      
      if (!printWindow) {
        toast.error("Veuillez autoriser les fenêtres pop-up pour l'impression");
        setLoading(false);
        return;
      }
      
      // Show loading screen
      printWindow.document.write(`
        <html>
          <head>
            <title>Étiquette commande #${order.reference || order.id || ''}</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
                margin: 0;
                padding: 0;
                flex-direction: column;
              }
              .loading {
                text-align: center;
              }
              .spinner {
                border: 5px solid #f3f3f3;
                border-top: 5px solid #3498db;
                border-radius: 50%;
                width: 50px;
                height: 50px;
                animation: spin 1s linear infinite;
                margin: 20px auto;
              }
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            </style>
          </head>
          <body>
            <div class="loading">
              <div class="spinner"></div>
              <h2>Préparation de l'étiquette...</h2>
            </div>
          </body>
        </html>
      `);
      
      // Create a container for the React component
      const container = document.createElement('div');
      document.body.appendChild(container);
      
      // Render the BatchPrint component with only this order
      ReactDOM.render(
        <BatchPrint
          orders={[order]} 
          logo="/logo-print.png"
          mylerzLogo="/mylerz.png"
        />,
        container
      );
      
      // Wait a bit to ensure rendering is complete
      setTimeout(() => {
        // Get the rendered HTML
        const content = container.innerHTML;
        
        // Update the print window with the actual content
        printWindow.document.open();
        printWindow.document.write(`
          <html>
            <head>
              <title>Étiquette commande #${order.reference || order.id || ''}</title>
              <style>
                @page {
                  size: 148mm 210mm landscape;
                  margin: 0;
                }
                body {
                  margin: 0;
                  padding: 0;
                }
              </style>
            </head>
            <body>
              ${content}
              <script>
                window.onload = function() {
                  setTimeout(function() {
                    window.print();
                    window.close();
                  }, 500);
                };
              </script>
            </body>
          </html>
        `);
        printWindow.document.close();
        
        // Clean up
        document.body.removeChild(container);
        setLoading(false);
      }, 1000);
      
    } catch (error) {
      console.error("Error preparing print:", error);
      toast.error("Une erreur s'est produite lors de la préparation de l'impression.");
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center space-x-2">
      {/* Export Button */}
      <button
        onClick={handlePrint}
        disabled={loading||!hasPermission('print')}
        className={`disabled:bg-gray-400 disabled:text-gray-700  disabled:cursor-not-allowed inline-flex items-center px-2 py-1.5 border border-blue-500 shadow-sm text-sm font-medium rounded-md text-white ${
          loading ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'
        } focus:outline-none`}
        title="Exporter cette commande"
      >
        {loading ? (
          <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        ) : (
          <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        )}
      </button>

      {/* Edit Button */}
{  hasPermission("edit") &&   <Link
        to={`/admin/orders/${orderId}/edit`}
        onClick={() => {
          sessionStorage.setItem('ordersScrollY', window.scrollY);
          sessionStorage.setItem('lastClickedOrderId', String(orderId));
        }}
        className="inline-flex items-center px-2 py-1.5 border border-yellow-500 shadow-sm text-sm font-medium rounded-md text-white bg-yellow-500 hover:bg-yellow-600 focus:outline-none"
      >
        <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
        </svg>
      </Link>
}
      {/* Delete Button */}
      <button
      disabled={!hasPermission('delete')}
        onClick={() => handleDeleteOrder(orderId)}
        className="disabled:bg-gray-400 disabled:text-gray-700  disabled:cursor-not-allowed inline-flex items-center px-2 py-1.5 border border-red-500 shadow-sm text-sm font-medium rounded-md text-white bg-red-500 hover:bg-red-600 focus:outline-none"
      >
        <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </button>

      {/* View Button */}
{  hasPermission('readOne') &&     <Link
        to={`/admin/orders/${orderId}`}
        onClick={() => {
          sessionStorage.setItem('ordersScrollY', window.scrollY);
          sessionStorage.setItem('lastClickedOrderId', String(orderId));
        }}
        className="inline-flex items-center px-3 py-1.5 border border-[#174540] shadow-sm text-sm font-medium rounded-md text-white bg-[#174540] hover:bg-[#0d2926] focus:outline-none"
      >
        Voir
      </Link>
}    </div>
  );
};

export default OrderActionButtons;